import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { toast } from 'sonner';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface ConfirmMigrationResponse {
  status: 'success';
  studioId?: string;
}

const extractApiErrorMessage = (error: unknown): string => {
  if (error instanceof AxiosError) {
    const wrapped = error.response?.data?.error;
    if (typeof wrapped === 'string' && wrapped.trim()) {
      return wrapped;
    }
    if (
      wrapped &&
      typeof wrapped === 'object' &&
      'message' in wrapped &&
      typeof wrapped.message === 'string'
    ) {
      return wrapped.message;
    }
  }
  if (error instanceof Error) {
    return error.message;
  }
  return 'Failed to confirm migration.';
};

const confirmStripeConnectMigration = async (token: string) => {
  const response = await baseAPI.post<ConfirmMigrationResponse>(
    '/payment-processor/stripe-connect/confirm',
    { token },
  );
  return response.data;
};

export const useConfirmStripeConnectMigrationMutation = () => {
  return useMutation({
    mutationFn: confirmStripeConnectMigration,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.STRIPE, KEYS.CREDENTIALS],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.STRIPE_CREDENTIAL_ENVIRONMENT],
      });
      toast.success('Stripe Connect migration completed');
    },
    onError: (error: unknown) => {
      toast.error(extractApiErrorMessage(error));
    },
  });
};
